import { gql, TypedDocumentNode } from '@apollo/client'

type GetTeamsByIdsData = { getTeams: any[] }
type GetTeamsByIdsVars = { ids: (string | undefined)[] }

export const GET_TEAMS_BY_IDS: TypedDocumentNode<
  GetTeamsByIdsData,
  GetTeamsByIdsVars
> = gql`
  query getTeams($ids: [ID]!) {
    getTeams(ids: $ids) {
      id
      teamName
      teamType
      updatedAt
      updatedBy {
        id
        lastName
        firstName
        companyName
        email
        lanId
      }
      businessPartner {
        id
        name
        type
      }
      createdAt
      createdBy {
        id
        firstName
        lastName
        companyName
        email
        lanId
      }
      partnerType {
        code
        description
      }
      status {
        code
        description
      }
      purpose
      members {
        id
        active
        companyName
        partnerId
        email
        firstName
        internal
        lastName
        lanId
        accreditations {
          code
          description
          status
        }
        roles {
          code
          description
        }
      }
    }
  }
`

type SearchTeamsData = {
  searchTeams: {
    content: any[]
    pageInfo: {
      pageNumber: number
      pageSize: number
      totalPages: number
      totalElements: number
    }
  }
}
type SearchTeamsVars = { page: number; q: string; size: number }

type SearchTeamsAutocompleteData = {
  searchTeams: { content: { id: string; teamName: string }[] }
}
type SearchTeamsAutocompleteVars = { q: string }

export const SEARCH_TEAMS_QUERY: TypedDocumentNode<
  SearchTeamsData,
  SearchTeamsVars
> = gql`
  query searchTeams($page: Int, $q: String!, $size: Int) {
    searchTeams(page: $page, q: $q, resourceType: "team", size: $size) {
      content {
        id
        teamName
        teamType
        businessPartner {
          id
          name
        }
        status {
          code
          description
        }
      }
      pageInfo {
        pageNumber
        pageSize
        totalPages
        totalElements
      }
    }
  }
`

export const SEARCH_TEAMS_AUTOCOMPLETE: TypedDocumentNode<
  SearchTeamsAutocompleteData,
  SearchTeamsAutocompleteVars
> = gql`
  query searchTeamsTypeahead($q: String!) {
    searchTeams(page: 0, q: $q, resourceType: "team", size: 20) {
      content {
        id
        teamName
      }
    }
  }
`
